<template>
  <v-card>
    <v-toolbar flat>
      <div>
        <v-toolbar-title class="text-h6 font-weight-regular">Customer ROI Data</v-toolbar-title>
      </div>
    </v-toolbar>
      <v-container class="ma-0 mp-0">
        <v-form ref="customerRoiForm" autocomplete="off">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <p class="text-subtitle-1 font-weight-medium">1) Options:</p>
              </v-col>
              <v-col cols="9">
                <v-radio-group v-model="roiType" class="mp-0 ma-0">
                  <v-radio
                    v-for="rptType in roiTypes"
                    v-bind:key="rptType.value"
                    :label="rptType.text"
                    :value="rptType.value"></v-radio>
                </v-radio-group>
                <v-checkbox
                  v-model="includeExcelRoi"
                  label="As Excel ROI Report"
                >
                </v-checkbox>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3">
                <p class="text-subtitle-1 font-weight-medium">2) Date Range:</p>
              </v-col>
           </v-row>

            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>ROI Start Date</v-subheader>
              </v-col>
              <v-col cols="3">
                <ymd-datepicker
                  v-model="roiStartDate"
                  placeholder="Roi Start Date"
                  required
                  :rules="vruleFieldRequired"
                  hint="*Required"
                  persistent-hint
                ></ymd-datepicker>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>ROI End Date</v-subheader>
              </v-col>
              <v-col cols="3">
                <ymd-datepicker
                  v-model="roiEndDate"
                  placeholder="Roi Start Date"
                  required
                  :rules="vruleFieldRequired"
                  hint="*Required"
                  persistent-hint
                ></ymd-datepicker>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>Minimum Days Between</v-subheader>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="roiDaysBetween"
                  placeholder="Days Between"
                  suffix="days"
                  required
                  :rules="vruleFieldRequired"
                  type="number"
                  min="0"
                  step="1"
                ></v-text-field>
              </v-col>
            </v-row>

          </v-card-text>
        </v-form>
      </v-container>
  </v-card>
</template>

<script>
import YMDDatePicker from '@/components/inputs/YMDDatePicker'
import { mapGetters, mapActions } from 'vuex'
import validationMixin from '@/validators/validations_mixin'
import StepHelperMixin from './StepHelperMixin'
import { path } from 'ramda'

export default {
  name: 'customer-roi',
  mixins: [validationMixin, StepHelperMixin],
  components: {
    [YMDDatePicker.name]: YMDDatePicker
  },
  data: function () {
    return {
      roiTypes: [
        { text: 'Include any Customer transactions', value: 'customer' },
        { text: 'Include Customer and VIN specific transactions', value: 'customer+vin' }
      ]
    }
  },
  computed: {
    componentName () {
      return this.$options.name
    },
    roiStartDate: {
      get () {
        return path(['start_date'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, key: 'start_date', value: val })
        this.validateStep()
      }
    },
    roiEndDate: {
      get () {
        return path(['end_date'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, key: 'end_date', value: val })
        this.validateStep()
      }
    },
    roiDaysBetween: {
      get () {
        return path(['days_between'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, key: 'days_between', value: val })
        this.validateStep()
      }
    },
    roiType: {
      get () {
        return path(['roi_type'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, key: 'roi_type', value: val })
        this.validateStep()
      }
    },
    includeExcelRoi: {
      get () {
        return path(['include_excel_roi'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, key: 'include_excel_roi', value: val })
        this.validateStep()
      }
    }
  },
  methods: {
    ...mapActions('CsvMappingStore', ['updateMappingTransformData']),
    ...mapGetters('CsvMappingStore', ['mappingTransformData']),
    validateStep () {
      // no validation - can always continue
      this.setStepIsValid(this.roiStartDate && this.roiEndDate && this.roiDaysBetween)
    }
  }
}
</script>
